import { Logo } from "./Header";
import { Phone, MapPin } from "lucide-react";

const PHONES = ["+234 706 379 2622", "+234 810 777 8448", "+234 812 480 1607"];

export default function Footer() {
  return (
    <footer className="bg-[#080E22] border-t border-slate-800 py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-slate-500 leading-relaxed max-w-xs" data-testid="footer-tagline">
            Petroleum products supply, logistics and nationwide distribution — delivered with dignity, integrity and distinction.
          </p>
        </div>
        <div>
          <h4 className="font-display font-bold text-white text-sm tracking-widest uppercase mb-5">Quick Links</h4>
          <nav className="flex flex-col gap-3 text-sm" data-testid="footer-nav">
            <a href="#about" data-testid="footer-link-about" className="text-slate-400 hover:text-amber-500 transition-colors">About Us</a>
            <a href="#services" data-testid="footer-link-services" className="text-slate-400 hover:text-amber-500 transition-colors">Services</a>
            <a href="#order" data-testid="footer-link-order" className="text-slate-400 hover:text-amber-500 transition-colors">Order Diesel</a>
            <a href="#fleet" data-testid="footer-link-fleet" className="text-slate-400 hover:text-amber-500 transition-colors">Our Fleet</a>
            <a href="#contact" data-testid="footer-link-contact" className="text-slate-400 hover:text-amber-500 transition-colors">Contact</a>
            <a href="/admin" data-testid="footer-link-admin" className="text-slate-600 hover:text-amber-500 transition-colors">Staff Login</a>
          </nav>
        </div>
        <div>
          <h4 className="font-display font-bold text-white text-sm tracking-widest uppercase mb-5">Contact</h4>
          <div className="space-y-3 text-sm text-slate-400" data-testid="footer-contact">
            <p className="flex items-start gap-2"><MapPin size={15} className="text-amber-600 mt-0.5 shrink-0" /> No 1 Alasia Street, Ikorodu/Shagamu Express Road, Ogijo, Lagos</p>
            {PHONES.map((p, i) => (
              <a key={p} href={`tel:${p.replace(/\s+/g, "")}`} data-testid={`footer-phone-${i + 1}`} className="flex items-center gap-2 hover:text-amber-500 transition-colors">
                <Phone size={15} className="text-amber-600" /> {p}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 mt-12 pt-6 border-t border-slate-800/70 text-center text-xs text-slate-600" data-testid="footer-copyright">
        &copy; {new Date().getFullYear()} Motaps Global Investment Limited. All rights reserved.
      </div>
    </footer>
  );
}
